import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

interface StarIconProps {
  className?: string;
}

const StarIcon: FunctionComponent<StarIconProps> = ({ className }) => {
  return (
    <svg className={className || ''} viewBox="0 0 16 16">
      <Path d="M8.95,.61l1.76,3.82c.15,.32,.45,.54,.8,.57l3.54,.38c.93,.11,1.28,1.3,.56,1.9l-2.81,2.37c-.28,.24-.41,.62-.33,.98l.89,4.05c.21,.93-.78,1.65-1.57,1.16l-3.27-2.04c-.32-.2-.73-.2-1.06,0l-3.27,2.04c-.79,.49-1.77-.23-1.57-1.16l.89-4.05c.08-.36-.05-.74-.33-.98L.38,7.28c-.72-.61-.37-1.8,.56-1.9l3.54-.38c.35-.04,.65-.26,.8-.57L7.05,.61c.37-.81,1.52-.81,1.9,0Z" />
    </svg>
  );
};

export default StarIcon;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.black};
`;
